export default __webpack_public_path__ + "static/media/Q12019.42ff5909.PDF";